import { FooterButtonGroup, FooterButton } from "../../canvas-controls/footer";
import style from "./timer-button.module.css";
import { CanvasTimer } from "frontend/hooks/use-timer";
import classNames from "classnames";
import tracking from "frontend/tracking";
import consts from "shared/consts";

export function TimerButton({
  relativeTo,
  timer,
  isOnline,
  showTimer,
  setShowTimer,
  setShowSideMenuOverflow,
  onClick,
}: {
  relativeTo: React.RefObject<HTMLElement>;
  timer: CanvasTimer;
  isOnline: boolean;
  showTimer: boolean;
  setShowTimer: (show: boolean) => void;
  setShowSideMenuOverflow: (show: boolean) => void;
  onClick?: () => void;
}) {
  const buttonRef = relativeTo as React.RefObject<HTMLDivElement>;

  function handleClick() {
    setShowSideMenuOverflow(false);
    if (!showTimer) {
      setShowTimer(true);
      tracking.trackEvent(consts.TRACKING_CATEGORY.CANVAS_ACTION, "open-timer-click", "timer-button");
    } else {
      setShowTimer(false);
    }
  }
  return (
    <FooterButtonGroup>
      <FooterButton
        tooltip="Timer"
        onClick={() => {
          onClick ? onClick() : handleClick();
        }}
        testid="timer-button"
        ref={buttonRef}
        disabled={!isOnline}
        styles={[style.alignLeft]}
      >
        <div
          className={classNames(style.timerButton, {
            [style.timerButtonColor]: showTimer || (!showTimer && timer.config.isRunning),
          })}
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_11415_43)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.4792 0H7.86853V1.55497H12.4792V0ZM10.1738 4.71476C6.54215 4.71476 3.55497 7.76426 3.55497 11.5801C3.55497 15.396 6.54215 18.4455 10.1738 18.4455C13.8054 18.4455 16.7926 15.396 16.7926 11.5801C16.7926 7.76426 13.8054 4.71476 10.1738 4.71476ZM2 11.5801C2 6.95393 5.6357 3.15979 10.1738 3.15979C14.7119 3.15979 18.3476 6.95393 18.3476 11.5801C18.3476 16.2063 14.7119 20.0005 10.1738 20.0005C5.6357 20.0005 2 16.2063 2 11.5801ZM10.9512 7.52698V10.8025H13.0644V12.3575H9.39624V7.52698H10.9512Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_11415_43">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
          {!showTimer && timer.config.isRunning && (
            <div className={style.timerText}>
              <p>{`${timer.minutesString}:${timer.secondsString}`}</p>
            </div>
          )}
        </div>
      </FooterButton>
      {/* TODO:should add a walkthtough tip for the timer */}
    </FooterButtonGroup>
  );
}
